import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8fa82c5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "right-operate-area"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.showActionBar)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "action-bar-wrap",
        style: _normalizeStyle({
      height: $setup.actionBarHeightRem,
      paddingTop: $setup.statusBarHeightRem
    })
      }, [
        _createElementVNode("div", {
          class: "fake-action-bar",
          style: _normalizeStyle({
        height: $setup.actionBarHeightRem,
        paddingTop: $setup.statusBarHeightRem
      })
        }, null, 4),
        _createElementVNode("div", {
          class: "action-bar-container",
          style: _normalizeStyle({
        height: $setup.actionBarHeightRem,
        paddingTop: $setup.statusBarHeightRem,
        background: $setup.actionBarInfo.actionBarBg
      })
        }, [
          _createElementVNode("img", {
            src: $props.theme === 'white' ? $setup.whiteArrow : $props.backIcon,
            class: _normalizeClass(["action-bar-back", { 'action-bar-back-white': $props.theme === 'white' }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.goBack && $setup.goBack(...args)))
          }, null, 10, _hoisted_1),
          _createElementVNode("div", {
            class: _normalizeClass(["action-bar-title", { 'action-bar-title-white': $props.theme === 'white' }])
          }, _toDisplayString($setup.actionBarInfo.actionBarTitle), 3),
          ($props.needShare)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "action-bar-share",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.goShare && $setup.goShare(...args)))
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "right_operate_area", { class: "right-operate-area-con" }, undefined, true)
              ]))
        ], 4)
      ], 4))
    : _createCommentVNode("", true)
}